export default __webpack_public_path__ + "static/media/arrow.08344087.svg";